import './MinimumOrder.css'

function MinimumOrder() {
    return (
    <div className="MinimumOrder">
        <article className='notice'>        
            <p>
                Ricordiamo a tutti i clienti che come previsto dal regolamento del bando BENI del Mercato Elettronico delle Pubbliche Amministrazioni, ed in via più specifica nei seguenti allegati:
                <ul>
                    <li>
                        Allegato n°3 al Capitolato d'oneri “Prodotti” per il settore merceologico “Arredi, Complementi ed Elettrodomestici” - Punto 6.1
                    </li>
                    <li>
                        Allegato n°7 al Capitolato d'oneri “Prodotti” per il settore merceologico “Informatica, Elettronica, Telecomunicazioni, Macchine per Ufficio” - Punto 8.5
                    </li>
                    <li>
                        Allegato n°8 al Capitolato d'oneri “Prodotti” per il settore merceologico “Cancelleria, Carta e Consumabili” - Punto 7.1
                    </li>
                </ul>
            </p>
            <p>
                <em>L'ordine minimo è pari ad Euro 400 + IVA per ogni singola consegna.</em>
            </p>
            <p>
                Sotto tale soglia le aziende possono legittimamente rifiutare l'ordinativo o possono chiedere alle amministrazioni una compartecipazione alle spese di gestione (oneri di incasso, spese amministrative) e spedizione.
            </p>

            <p>
                Virtual Logic S.r.l. opera con le seguenti modalità:
                <ul>
                    <li>
                        Ordini con imponibile inferiore a 200 Euro + Iva non vengono processati e saranno rifiutati tramite la piattaforma;
                    </li>
                    <li>
                        Ordini con imponibile compreso tra 200 Euro + Iva e 399 Euro + IVA:<br/>
                        Per questi è prevista la possibilità di evasione autorizzando preventivamente nel campo note dell'ordine stesso l'addebito di 14 Euro + IVA per spese di gestione e spedizione.
                        In caso l'ordine venga inoltrato senza questa dicitura il nostro personale provvederà a chiedere al punto ordinante autorizzazione all'addebito delle spese prima di provvedere al rifiuto.
                    </li>
                    <li>
                        Ordini con imponibile superiore a 400 Euro + Iva sono congrui al disciplinare e sono processati senza alcun onere per la pubblica amministrazione.
                    </li>
                </ul>
            </p>
        </article>
        
    </div>
    )
}

export default MinimumOrder